<template>
  <div>
    <div class="thumb-example">
      <!-- swiper1 -->
      <swiper
        class="swiper gallery-top"
        :options="swiperOptionTop"
        ref="swiperTop"
      >
        <swiper-slide class="slide-1" v-for="item in list" :key="item.id">
          <img class="img" :src="item.imgUrl" style="width:100%;"/>
          <div class="pos-abs" style="top: 2%; left: 10%">
            <div class="fs-28 fc-white ls-1">
              <h3>精选热门广播剧</h3>
              <h3>畅听不停歇</h3>
            </div>
            <div class="lead fc-white margin-t-5">
              <h4>{{ item.name }}</h4>
            </div>
            <div class="small fc-white margin-t-5">
              <h5>
                {{ item.desc }}
              </h5>
            </div>
            <div class="small fc-white margin-t-5">
              <h5>原著： {{ item.author }}</h5>
            </div>
            <div class="small margin-t-5">
              <div class="btn btn-view small">
                立即播放
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
  
  <script>

export default {
  name: "hot",
  components: {},
  data() {
    return {
      list: [
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "1w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "2w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "3w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "4w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "5w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "6w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "7w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "8w",
          imgUrl: "/static/images/album/04.png",
          thumbUrl: "/static/images/album/04.png",
        },
      ],
      swiperOptionTop: {
        zoom: true,
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 20,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // autoplay: {  //自动轮播
        //   delay: 2000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    };
  },
  methods: {
    init() {
      
    },
  },
  created() {
    
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
      }, 1000);
    });
  },
};
</script>
  
<style  scoped>
.swiper-slide-active {
  background: #4f4f4f;
  border-top: 3px solid #ff8d1a;
}
</style>
  


// WEBPACK FOOTER //
// src/page/homepage/components/md/hot.vue